import { Box, Stack, styled } from "@mui/material";
import pxToRem from "theme/base/pxToRem";

export const Tabs = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  gap: pxToRem(16),
  margin: `${pxToRem(20)} ${pxToRem(16)}`,
}));

export const Tab = styled(Box)<{ active?: boolean }>(({ theme, active }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: `${pxToRem(10)} ${pxToRem(16)}`,
  backgroundColor: active
    ? theme.palette.background.bgBrandPrimary
    : theme.palette.background.bgTertiary,
  color: active
    ? theme.palette.text.textLink
    : theme.palette.text.textSecondary,
  borderRadius: pxToRem(8),
  textAlign: "center",
  cursor: "pointer",
}));

export const TabContent = styled(Box)(({ theme }) => ({
  overflow: "scroll",
  flex: 1,
  height: "100%",
  margin: `0 ${pxToRem(16)}`,
  table: {
    thead: {
      th: {
        div: {
          justifyContent: "right",
        },
      },
    },
    tbody: {
      tr: {
        td: {
          width: "100%",
          textAlign: "right",
          justifyContent: "flex-end",
        },
      },
    },
  },
}));

export const BoxIconHoliday = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  svg: {
    path: {
      fill: theme.palette.colorsBase.violet_0,
    },
  },
}));

export const ContentModalCancelRequest = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: pxToRem(16),
  alignItems: "center",
  ".iconWrapper": {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: pxToRem(52),
    height: pxToRem(52),
    borderRadius: "50%",
    backgroundColor: theme.palette.background.bgWarningPrimary,
  },
  ".textContent": {
    display: "flex",

    width: `100%`,
    justifyContent: "left",
    alignItems: "center",
    gap: pxToRem(16),
    p: {
      textAlign: "center",
      fontSize: theme.typography.size.md_16,
      color: theme.palette.text.textPrimary,
      fontWeight: theme.typography.fw_semibold_600,
      maxWidth: pxToRem(250),
    },
  },
  ".reason": {
    width: "100%",
    display: "flex",
    justifyContent: "left",
  },
  svg: {
    width: pxToRem(36),
    height: pxToRem(36),
    marginBottom: pxToRem(5),
  },
}));
